import type { PaymentGateway, PaymentMethodUsage } from '@change-corgi/middle-end-gql-schema';

import { usePromotePageState } from 'src/app/pages/promote/pageContext';
import type { PaymentType } from 'src/app/shared/utils/payments';

import { useIsMembershipEligible } from '../useIsMembershipEligible';

const SAVE_ELIGIBLE_PAYMENT_TYPES = ['creditCard', 'sepa'];
const ELIGIBLE_PAYMENT_TYPES = [...SAVE_ELIGIBLE_PAYMENT_TYPES, 'applePay', 'googlePay'];

export function useSetupFutureUsage(): (
	gateway: PaymentGateway,
	paymentType: PaymentType,
) => { setupFutureUsage: PaymentMethodUsage } | undefined {
	const [{ paymentMethodSaveOptions, usingSavedPaymentMethod }] = usePromotePageState();
	const isEligibleForMembership = useIsMembershipEligible();

	// reusable token is needed for Stripe payment methods
	// when user is eligible for membership and they has not elected to save their payment method
	return function setupFutureUsage(gateway, paymentType) {
		if (usingSavedPaymentMethod) return undefined;
		if (gateway !== 'STRIPE') return undefined;
		if (!isEligibleForMembership) return undefined;
		if (!ELIGIBLE_PAYMENT_TYPES.includes(paymentType)) return undefined;
		if (SAVE_ELIGIBLE_PAYMENT_TYPES.includes(paymentType) && paymentMethodSaveOptions.shouldSavePaymentMethod)
			return undefined;
		return { setupFutureUsage: 'ON_SESSION' };
	};
}
